import React, {memo, useMemo, useState} from 'react';
import { useLocation } from "react-router-dom";
import {useSelector} from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay,FreeMode,Navigation,Thumbs } from 'swiper';
import * as TYPES from '../../models/types';
import { isMath, isNormalZhEnCss } from '../../utils';

import 'swiper/css';
import styles from './styles.module.scss';

// install Swiper modules
SwiperCore.use([Autoplay, FreeMode,Navigation,Thumbs]);

const Index = memo((props) => {

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const {lang, travelMall } = useSelector(({localesReducer}) => localesReducer.i18n);

  const { options } = useSelector(({basicDrawerReducer}) => basicDrawerReducer);
  const [ esaWidthVal, setEsaWidthVal ] = useState(recReSizeReducer <= 750 ? `initial` : isMath(recReSizeReducer, 1000));

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  // 获取 History
  let location = useLocation();

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setEsaWidthVal(1000);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setEsaWidthVal(1000);
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setEsaWidthVal(895);
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setEsaWidthVal(613);
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setEsaWidthVal(`initial`);
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  }, [recReSizeReducer, esaWidthVal]);

  const isTour = () => {
    const { type } = options;
    if(type){
      switch(type){
        case TYPES.domesticTourType:
          return true;
        case TYPES.overseasTourType:
          return true;
        default: 
          return false;  
      }
    }
  }
  
  const carouselSwiper = () => {
    const { type, index } = options;
    if(type) {
      const data = travelMall[type].list[index];
      return (
          <div className="bannerCarouselView">
            <Swiper
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff'
                }}
                spaceBetween={0}
                navigation={true}
                autoplay={{
                  "delay": 2500,
                  "disableOnInteraction": false
                }}
                loop
                speed={1000}
                thumbs={{
                  swiper: thumbsSwiper
                }}
                className="swiper bannerCarouselMain"
            >
              {data.banner.map(item => {
                return (<SwiperSlide key={item.id} style={{background: `url(${item.img}) no-repeat 50% 100%/cover`}} />)
              })}
            </Swiper>

            <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={8}
                slidesPerView={3}
                freeMode={true}
                watchSlidesProgress={true}
                className="swiper bannerCarouselFoot"
            >
              {data.banner.map(item => {
                return ( <SwiperSlide key={item.id}><img src={item.img} alt=""/></SwiperSlide>)
              })}
            </Swiper>
          </div>
      );
    }


  }

  // 桌面
  const bannerCarouselInfoDesktop = () => {

    const { type, index } = options;
    if(type){
      const data = travelMall[type].list[index];
      return (
          <div className="bannerCarouselInfo">
            <div className="innerBox">
              <div 
                className="innerTitleContent"
                ref={props.config.getRefs.innerTitleContentRef}
                style={props.config.getRefs.innerTitleContentStyles}
              >
                <div className="innerTitleRol flex flex-row justify-between items-center">
                  <div className="titleRolL flex flex-row justify-center items-center">
                    <h5><span>{data.title}</span></h5>
                    <div className="map flex flex-row justify-center items-center">
                      <i><img src={data.markMap} alt="" /></i>
                      <span>{data.address}</span>
                    </div>
                  </div>
                  <div className="titleRolR flex flex-row justify-center items-center">
                    <span>{data.money}</span>
                    <span>{data.people}</span>
                  </div>
                </div>
                <div className="innerTitleRol flex flex-row justify-between items-center">
                  <div className="titleRol flex flex-row justify-center items-center">
                    <span>{data.days}</span>
                    <span>{data.group}</span>
                  </div>
                  <div className="titleRol flex flex-row justify-center items-center">
                    <span>{data.total}</span>
                  </div>
                </div>
              </div>
              <div 
                className="innerDescContent"
                ref={props.config.getRefs.innerDescContentRef}
                style={props.config.getRefs.innerDescContentStyles}
              >
                {
                  data.content.map(item => {
                    return (<p key={item.key} ><span>{item.desc}</span></p>);
                  })
                }
              </div>
            </div>
          </div>
      );
    }


  }
  // 移动端
  const bannerCarouselInfoMobiles = () => {
    const { type, index } = options;
    // initSpan  longSpan
    if(type){
      const data = travelMall[type].list[index];
      const isClassName = data.title.length > 11 ? 'longSpan' : 'initSpan';
      return (
          <div className="bannerCarouselInfo">
            <div className="innerBox">
              <div 
                className="innerTitleContent"
              >
                <div className="innerTitleRol flex flex-row justify-between items-center">
                  <div className="titleRolL flex flex-row justify-center items-center">
                    <h5><span className={isClassName}>{data.title}</span></h5>
                    <div className="map flex flex-row justify-center items-center">
                      <i><img src={data.markMap} alt="" /></i>
                      <span>{data.address}</span>
                    </div>
                  </div>
                </div>
                <div className="innerTitleRol flex flex-row justify-between items-center">
                  <div className="titleRolR flex flex-row justify-center items-center">
                    <span>{data.days}</span>
                    <span>{data.group}</span>
                  </div>
                </div>
                <div className="innerTitleRol flex flex-row justify-between items-center">
                  <div className="titleRol flex flex-row justify-center items-center">
                    <span>{data.money}</span>
                    <span>{data.people}</span>
                  </div>
                  <div className="titleRol flex flex-row justify-center items-center">
                    <span>{data.total}</span>
                  </div>
                </div>
              </div>
              <div 
                className="innerDescContent"
                ref={props.config.getRefs.innerDescContentRef}
                style={props.config.getRefs.innerDescContentStyles}
              >
                {
                  data.content.map(item => {
                    return (<p key={item.key} ><span>{item.desc}</span></p>);
                  })
                }
              </div>
            </div>
          </div>
      );
    }

  }

  const eightServicesAllInclusive = () => {
    const { inclusiveAll: {title, list, desc} } = travelMall;
    return (
        <>
          <div 
            className="eightServicesAllInclusive" 
            ref={props.config.getRefs.innerESAllILSVRef}
            style={{width: esaWidthVal, ...props.config.getRefs.innerESAllILSVStyles}}
          >
            <h5 
              className="title"
              ref={props.config.getRefs.innerEATitleRef}
              style={props.config.getRefs.innerEATitleStyles}
            >
              <span>{title}</span>
            </h5>
            <ul
              ref={props.config.getRefs.innerEAULRef}
              style={props.config.getRefs.innerEAULStyles}
            >
              {
                list.map(item => {
                  return (
                      <li key={item.id}>
                        <i><img src={item.img} alt=""/></i>
                        <p><span>{item.desc}</span></p>
                      </li>
                  );
                })
              }
            </ul>
          </div>
          <div 
              className="subText"
              ref={props.config.getRefs.innerESSubRef}
              style={props.config.getRefs.innerESSubStyles}
          >
            <span >{desc}</span>
          </div>
        </>
    );
  }

  // 移动端
  const bannerCarouselInfo = () => {
    return recReSizeReducer <= 750 ? bannerCarouselInfoMobiles() : bannerCarouselInfoDesktop();
  };


  const travelMallRender = () => {
    return (
        <>
          {carouselSwiper()}
          {bannerCarouselInfo()}
          {eightServicesAllInclusive()}
        </>
    );
  }


  // 判断是：桌面/移动端
  const desktopMobile = () => {
    // options.doTour
    const isName = location.pathname === '/travelmall' || options.doTour === TYPES.TRAVELMALL;
    return isTour() ? (
        <div className={normal}>
          {/* { location.pathname === '/travelmall' ?  travelMallRender() : null} */}
          { isName ?  travelMallRender() : null}
        </div>
    ) : null;
  };

  return desktopMobile();
});
export default Index;
